import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "128",
  height: "133",
  viewBox: "0 0 128 133",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M62.1862 8.41504C62.186 3.04676 56.6799 -0.704522 51.8542 2.10059C33.3966 12.8305 7.52911 36.2891 7.52899 71.6455C7.52899 91.0404 14.2801 104.571 23.7038 113.768C33.1028 122.94 45.0941 127.738 55.5114 129.826C64.7096 131.67 62.4296 130.742 64.8981 131.053L64.9323 131.057L64.9665 131.059C66.0924 131.123 67.1755 131.154 68.2077 131.154C77.0957 131.154 90.3844 128.175 101.472 119.23C112.603 110.251 121.426 95.3293 121.426 71.6455C121.426 52.9432 111.588 40.3782 102.208 33.2227C99.3157 31.0167 95.9747 31.0029 93.2917 32.4678C90.6353 33.9183 88.657 36.7919 88.2966 40.3105L87.7321 45.8252C87.4138 48.9323 85.8375 51.7249 83.7565 53.2988C81.7178 54.8407 79.234 55.2076 76.8093 53.6318C71.5179 50.1931 67.8511 44.2853 65.5056 37.9697C63.1642 31.6653 62.1863 25.0796 62.1862 20.4512V8.41504Z",
      fill: "#FB923C",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M93.8341 103.559C93.8341 123.231 77.9517 129.314 68.1291 130.152C64.7747 129.73 68.1291 130.898 57.4823 128.767C49.6691 126.012 41.1764 118.937 41.1764 103.559C41.1764 93.8143 47.3344 87.802 52.1587 84.9876C53.6345 84.1266 55.3484 85.2106 55.4803 86.9118C55.8986 92.3042 61.0856 96.5991 64.6193 92.4991C67.7421 88.8759 69.054 83.5832 69.054 80.1972V75.7728C69.054 73.1054 71.7439 71.3382 74.0421 72.6992C82.5873 77.7596 93.8341 88.1703 93.8341 103.559Z",
      fill: "#FBBF24"
    }, null, -1)
  ])))
}
export default { render: render }